import { useEffect, useState } from "react";

import labelSaEtab from "../../assets/images/watch/label-sa-etab.png";
import labelPaEtab from "../../assets/images/watch/label-pa-etab.png";
import Loader from "../../components/ui/Loader";
import useStore from "../../hooks/store/useStore";
import useQueryCustom from "../../services/utils/useQueryCustom";

import BookButton from "../bookDemo/BookButton";
import Label from "./components/Label";
import VideoList from "./components/VideoList";
import MainCard from "./components/MainCard";
import convertToVideoDataWithVimeoUrl from "./utils/convertToVideoDataWithVimeoUrl";
import { VideoDataType } from "./types";

export default function Watch() {
  const [firstVideo, setFirstVideo] = useState<VideoDataType | null>(null);
  const [currentVideo, setCurrentVideo] = useState<VideoDataType | null>(null);
  const [tbcVideoData, setTbcVideoData] = useState<VideoDataType[] | null>(
    null,
  );
  const [paVideoData, setPaVideoData] = useState<VideoDataType[] | null>(null);
  const [saVideoData, setSaVideoData] = useState<VideoDataType[] | null>(null);

  const { userInformation } = useStore((state) => state.user);
  const { market } = userInformation || {};

  const {
    data: tbcData,
    isLoading: loadingTbc,
    isError: errorTbc,
  } = useQueryCustom("useTBCVideoList", "TBC/video-list");
  const {
    data: paData,
    isLoading: loadingPa,
    isError: errorPa,
  } = useQueryCustom("usePAVideoList", "PA/video-list");
  const {
    data: saData,
    isLoading: loadingSa,
    isError: errorSa,
  } = useQueryCustom("useSAVideoList", "SA/video-list");

  useEffect(() => {
    if (paData && paData.length > 0) {
      const videoData = convertToVideoDataWithVimeoUrl(paData);
      const firstVideo =
        videoData.find((video: VideoDataType) => !video.locked) || null;

      setPaVideoData(videoData);
      setFirstVideo(firstVideo);
    }
  }, [paData, setFirstVideo, market]);

  useEffect(() => {
    if (tbcData && tbcData.length > 0)
      setTbcVideoData(convertToVideoDataWithVimeoUrl(tbcData));
  }, [tbcData]);

  useEffect(() => {
    if (saData && saData.length > 0)
      setSaVideoData(convertToVideoDataWithVimeoUrl(saData));
  }, [saData]);

  if (
    loadingTbc ||
    loadingPa ||
    loadingSa ||
    !firstVideo ||
    !paVideoData ||
    !saVideoData
  )
    return <Loader page="watch" />;
  if (errorTbc || errorPa || errorSa) return <p>Error</p>;

  return (
    <div className="w-full p-5">
      <MainCard firstVideo={firstVideo} currentVideo={currentVideo} />

      {tbcVideoData ? (
        <VideoList
          listType="tbc"
          data={tbcVideoData}
          setCurrentVideo={setCurrentVideo}
        />
      ) : null}

      <Label text="Play Along!" url={labelPaEtab} />

      <VideoList
        listType="pa"
        data={paVideoData}
        setCurrentVideo={setCurrentVideo}
      />

      <Label text="Sing Along!" url={labelSaEtab} />

      <VideoList
        listType="sa"
        data={saVideoData}
        setCurrentVideo={setCurrentVideo}
      />

      <BookButton sourcePage="Watch" />
    </div>
  );
}
